export default "__VITE_ASSET__7H06yvea__"